import React from 'react';
const ContactUsSubmissionHeader = () => (
  <h1>We appreciate your questions and feedback</h1>
);

export default ContactUsSubmissionHeader;
